import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const reload = () => window.location.reload()

const redirect = (itemId) => {
  let url = process.env.REACT_APP_CATALOG_URI + '/item/' + itemId + '?a=' + new Date().getTime()
  window.location.replace(url)
}
const GET_DELETE_ITEM_QUERY = gql`
  mutation DeleteItemQuery($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      itemId
    }
  }
`
export default function DeleteItemModal(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [deleteItem] = useMutation(
    GET_DELETE_ITEM_QUERY,
    {
      variables: {
        input: {
          itemId: props.itemId
        }
      }
    }
  )

  return (
    <Modal {...props} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Delete Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={e => {
            e.preventDefault()
            setIsLoading(true)
            deleteItem().then(
              result => {
                let parentItemId = result.data.deleteItem.itemId
                props.onHide()
                setIsLoading(false)
                redirect(parentItemId)
              },
              error => {
                console.log('Delete Item failed with error: ', error)
                setIsLoading(false)
                props.onHide()
              }
            )
          }}
        >
          <h3>Delete Item and all its attached files:</h3>
          <br />
          <p>You are about to delete this item and all its attached files. Clicking Yes will delete the item and all its files and will take you back to Catalog parent item.
            Do you wish to proceed? </p>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>No</Button>
            <Button variant="primary" type="submit">{isLoading ? <span ><FontAwesomeIcon icon={faSpinner} pulse /></span> : ''}&nbsp;Yes</Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

DeleteItemModal.propTypes = {
  onHide: PropTypes.func,
  itemId: PropTypes.string,
  parentItemId: PropTypes.string,
}
